jQuery(document).ready(function () {

    jQuery('.data-container-info').on('change', '.filters-aside input.form-check-input', function () {
        const info = jQuery(this).closest('.data-container-info')
        const $form = jQuery(this).closest('.filters-aside')
        const ajaxUrl = info.data('ajax-url')
        const resultsSelector = info.data('results-selector')
        const blockedElementsStr = info.data('blocked-elements')
        const blockedElements = blockedElementsStr ? blockedElementsStr.split(',').map(s => s.trim()) : []
        const loading = info.data('loading')
        const loadingPanel = document.querySelector('#loading')

        // Función para mostrar loading
        function showLoading() {
            console.log('Mostrando loading...')
            if (loadingPanel) loadingPanel.classList.add('show')
            blockedElements.forEach(id => {
                document.getElementById(id)?.classList.add('bloqueado')
            })
        }

        // Función para ocultar loading
        function hideLoading() {
            console.log('Ocultando loading...')
            if (loadingPanel) loadingPanel.classList.remove('show')

            blockedElements.forEach(id => {
                document.getElementById(id)?.classList.remove('bloqueado')
            })
        }


        if (loading) {
            showLoading()
        } else {
            blockedElements.forEach(id => {
                document.getElementById(id)?.classList.add('bloqueado')
            })
        }

        const filter = jQuery(this).closest('ul.list-group.list-group-flush')

        if (!filter[0]) return

        const any = filter[0].querySelector('input.form-check-input.any-value')
        const inputs = filter[0].querySelectorAll('input.form-check-input')

        // Helper para desmarcar inputs que no sean "Any"
        function makeUncheckedByAny() {
            inputs.forEach(inp => {
                if (!inp.classList.contains('any-value')) {
                    inp.checked = false
                }
            })
        }
        // Lógica visual de checkbox
        if (jQuery(this).is(':checked')) {
            if (jQuery(this).hasClass('any-value')) {
                jQuery(this).prop('disabled', true)
                makeUncheckedByAny()
            } else {
                if (any) {
                    any.checked = false
                    any.disabled = false
                }
            }
        } else if (Array.from(inputs).every(val => val.checked === false)) {
            if (any) {
                any.checked = true
                any.disabled = true
            }
        }

        // funcion que si no hay getFormDataCAllback hace un objeto basandose en FormData
        function getFormDataAsObject() {
            if (typeof window.getFormDataCallback === 'function') {
                return window.getFormDataCallback()
            }

            const formData = new FormData($form[0])
            const dataObject = {}

            for (let [key, value] of formData.entries()) {
                if (dataObject[key]) {

                    if (!Array.isArray(dataObject[key])) {
                        dataObject[key] = [dataObject[key]]
                    }
                    dataObject[key].push(value)
                } else {
                    dataObject[key] = value
                }
            }

            return dataObject
        }

        const formData = getFormDataAsObject()

        // ajax de post
        if (ajaxUrl && resultsSelector) {

            jQuery.ajax({
                url: ajaxUrl,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(formData),
                success: function (response) {
                    jQuery(resultsSelector).html(response)
                },
                error: function (xhr, status, error) {
                    console.error('Error:', error)
                    jQuery(resultsSelector).html('<p style="color: red;">Error: ' + error + '</p>')
                },
                complete: function () {
                    if (loading) {
                        hideLoading()
                    } else {
                        blockedElements.forEach(id => {
                            document.getElementById(id)?.classList.remove('bloqueado')
                        })
                    }
                }
            })
        } else {
            if (loading) {
                hideLoading()
            } else {
                blockedElements.forEach(id => {
                    document.getElementById(id)?.classList.remove('bloqueado')
                })
            }
        }

    })

})